import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, ProgressBar } from '../../components/ui';
import type { Gender } from '../../types';
import maleImage from '../../assets/onboarding/male.png';
import femaleImage from '../../assets/onboarding/female.png';

export function GenderScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleSelect = (gender: Gender) => {
    updateOnboarding({ gender });
  };

  const handleContinue = () => {
    if (onboarding.gender) {
      nextStep();
      navigate('/onboarding/age');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={2} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">What's your gender?</h1>
        <p className="text-secondary mb-8">
          This helps us personalize your analysis.
        </p>

        <div className="space-y-4 mb-8">
          <OptionCard
            selected={onboarding.gender === 'male'}
            onClick={() => handleSelect('male')}
            className="gender-card"
          >
            <div className="flex items-center gap-4">
              <img
                src={maleImage}
                alt="Male"
                className="w-28 h-28 rounded-xl object-cover"
              />
              <div>
                <div className="font-semibold text-xl">Male</div>
                <p className="text-sm text-secondary mt-1">Show me the best plan.</p>
              </div>
            </div>
          </OptionCard>

          <OptionCard
            selected={onboarding.gender === 'female'}
            onClick={() => handleSelect('female')}
            className="gender-card"
          >
            <div className="flex items-center gap-4">
              <img
                src={femaleImage}
                alt="Female"
                className="w-28 h-28 rounded-xl object-cover"
              />
              <div>
                <div className="font-semibold text-xl">Female</div>
                <p className="text-sm text-secondary mt-1">Personalize my glow-up.</p>
              </div>
            </div>
          </OptionCard>
        </div>
      </div>

      <p className="text-xs text-muted text-center mb-4 px-4">
        By continuing to use our app, you agree to our{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-secondary underline">
          Privacy Policy
        </a>{' '}
        and{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-secondary underline">
          Terms of Service
        </a>
        .
      </p>

      <Button
        onClick={handleContinue}
        disabled={!onboarding.gender}
      >
        Continue
      </Button>
    </div>
  );
}
